import React from 'react';
import './index.module.less';
import HalfScreenInfoModal from '@components/HalfScreenInfoModal';
import { IChildrenInfo } from './constants';

//私有常量

//可抽离的逻辑处理函数/组件

let ChildrenSelectMenu = (props: IProps) => {
  //变量声明、解构
  const { childrenInfo, currentDevice, onClose, onSelect } = props;

  //组件状态

  //网络IO

  //数据转换

  //逻辑处理函数
  // 选择小孩
  const handleSelectChildren = (childrenItem: IChildrenInfo) => {
    onSelect(childrenItem);
    onClose();
  };

  //组件Effect

  return (
    <HalfScreenInfoModal height="auto" onClose={onClose} hideCloseBtn={true}>
      <div styleName="children-title">请选择孩子</div>
      <div styleName="container">
        {childrenInfo.map(item => (
          <div
            key={item.bindUserName}
            styleName={
              currentDevice?.snCode === item.snCode
                ? 'children-item children-item-active '
                : 'children-item'
            }
            onClick={() => handleSelectChildren(item)}
          >
            {item.bindUserName ? item.bindUserName : `学生证${item.snCode}`}
          </div>
        ))}
      </div>
    </HalfScreenInfoModal>
  );
};

//props类型定义
interface IProps {
  /**
   * 全部绑定的孩子数据
   */
  childrenInfo: IChildrenInfo[];
  /**
   * 当前选中的孩子
   */
  currentDevice: IChildrenInfo;
  /**
   * 取消选择事件
   */
  onClose: () => void;
  /**
   * 确认选择事件
   */
  onSelect: (children: IChildrenInfo) => void;
}

//prop-type定义，可选

export default ChildrenSelectMenu;
